<dialog-wrapper>
    <span jeDialogTitle>{{ 'MASTER_DATA.INFO_WINDOW.DIALOG.TITLE' | translate }}</span>
    <je-message-box [type]="'info'">
        <div [innerHtml]="infoText | safeHtml" class="whitespace-pre-line froala-text"></div>
    </je-message-box>
</dialog-wrapper>
